import { main } from "../../../assets/coach-assets/constants/colors"
import { fontType } from "../../../assets/extras"

const ModalPlayerInfo = ({ playerInfo, setPlayerInfo }) => {
    return (
        <div>
            {
                playerInfo.show && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            backgroundColor: "rgba(0,0,0,0.5)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 1000,
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: "white",
                                width: "80%",
                                maxWidth: 700,
                                borderRadius: 20,
                                padding: 20,
                                border: "2px solid #000",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}
                        >
                            <button
                                onClick={() => setPlayerInfo((prev) => ({ ...prev, show: false }))}
                                style={{
                                    alignSelf: "flex-end",
                                    background: "transparent",
                                    border: "none",
                                    cursor: "pointer",
                                    fontSize: "20px",
                                    color: "red",
                                }}
                            >
                                ✖
                            </button>

                            <div style={{ width: "90%", fontFamily: fontType.text }}>
                                <div style={{ display: "flex", marginBottom: 15, marginTop: 10 }}>
                                    <span style={{ fontWeight: "bold", fontSize: 16, marginRight: 10 }}>Edad: </span>
                                    <span style={{ fontSize: 16 }}>{playerInfo.edad}</span>
                                </div>
                                <div style={{ display: "flex", marginBottom: 15 }}>
                                    <span style={{ fontWeight: "bold", fontSize: 16, marginRight: 10 }}>Categoría: </span>
                                    <span style={{ fontSize: 16 }}>{playerInfo.categoria}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

        </div>
    )
}

export default ModalPlayerInfo